import React, { useEffect, useState } from 'react';
import { Grid, MenuItem, Select, TextField, FormControl, InputLabel } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    plate: {
      // backgroundImage: 'url("/plate.png")',
      width: '100%',
      height: '58px',
      // backgroundPosition: 'center center',
      // backgroundRepeat: 'no-repeat',
      // backgroundSize: 'cover',
      border: "1px solid rgba(0, 0, 0, 0.23)",
      marginLeft: '0',
      marginTop: '5px',
      borderRadius: "4px",
      '& .MuiInputBase-root': {
        height: '30px',
        marginTop: '7px',
      },
    },
    input: {
      width: '100%',
      textAlign: 'center',
      height: '10px',
    },
    inputWrapper: {
    }
  })
);

export type Props = {
  getNumber: (number: string) => void;
  number?: string;
};

function Plate(props: Props) {
  const classes = useStyles();
  const [alphabet, setAlphabet] = useState('');
  const [irDigit, setIrDigit] = useState('');
  const [firstDigit, setFirstDigit] = useState('');
  const [secondDigit, setSecondDigit] = useState('');
  const alphabets = [
    'الف',
    'ب',
    'پ',
    'ت',
    'ث',
    'ج',
    'چ',
    'ح',
    'خ',
    'د',
    'ذ',
    'ر',
    'ز',
    'ژ',
    'س',
    'ش',
    'ص',
    'ض',
    'ط',
    'ظ',
    'ع',
    'غ',
    'ف',
    'ق',
    'ک',
    'گ',
    'ل',
    'م',
    'ن',
    'و',
    'ه',
    'ی',
  ];

  useEffect(() => {
    const number = firstDigit.concat(alphabet, secondDigit, '-', irDigit)
    props.getNumber(number);
    if (number === '-') {
      props.getNumber('');
    }
  }, [irDigit, firstDigit, secondDigit, alphabet]);

  useEffect(() => {
    if (props.number?.length === 9) {
      setFirstDigit(props.number.substring(0, 2));
      setAlphabet(props.number.substring(2, 3));
      setSecondDigit(props.number.substring(3, 6));
      setIrDigit(props.number.substring(7, 9));
    }
  }, [props.number]);

  return (
    <Grid className={classes.plate} container spacing={2} alignItems="center">
      <Grid item xs={3}>
        <TextField
          inputProps={{
            className: classes.input,
          }}
          onInput={e => {
            const value = parseInt(e.target.value);
            e.target.value = isNaN(value)
              ? ''
              : Math.max(0, value).toString().slice(0, 2);
          }}
          value={irDigit}
          placeholder="ایران"
          onChange={e => setIrDigit(e.target.value)}
          type="number"
          
        />
      </Grid>
      <Grid item xs={1}>_</Grid>
      <Grid item xs={3}>
        <TextField
          inputProps={{
            className: classes.input,
          }}
          onInput={e => {
            const value = parseInt(e.target.value);
            e.target.value = isNaN(value)
              ? ''
              : Math.max(0, value).toString().slice(0, 3);
          }}
          value={secondDigit}
          placeholder="123"
          onChange={e => setSecondDigit(e.target.value)}
          type="number"
        />
      </Grid>
      <Grid item xs={2}>
        <FormControl style={{ width: '100%' }}>
          <Select
            fullWidth
            id="alphabet"
            name="alphabet"
            inputProps={{
              name: 'alphabet',
              id: 'alphabet',
            }}
            labelId="alphabetLabel"
            value={alphabet}
            onChange={e => setAlphabet(e.target.value)}
            className={classes.input}
            placeholder="انتخاب"
          >
            {alphabets.map((item: any) => {
              return (
                <MenuItem key={item} value={item === 'الف' ? 'ا' : item}>
                  {item}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <TextField
          inputProps={{
            className: classes.input,
          }}
          onInput={e => {
            const value = parseInt(e.target.value);
            e.target.value = isNaN(value)
              ? ''
              : Math.max(0, value).toString().slice(0, 2);
          }}
          value={firstDigit}
          placeholder="12"
          onChange={e => setFirstDigit(e.target.value)}
          type="number"
        />
      </Grid>
    </Grid>
  );
}

export default Plate;
